import { useEffect, useState } from 'react';
import { ASSETS } from '@/lib/constants';
import { useMaintenanceStore } from '@/store/maintenance-store';
import { Button } from '@/components/ui/button';
import { RefreshCw } from 'lucide-react';

const MaintenancePage = () => {
  const { maintenanceMessage, estimatedDuration } = useMaintenanceStore();
  const [countdown, setCountdown] = useState(30);

  // Countdown para verificar novamente
  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [countdown]);

  // Função para recarregar a página
  const handleRefresh = () => {
    window.location.reload();
  };

  // Auto-refresh quando countdown chega a 0
  useEffect(() => {
    if (countdown === 0) {
      handleRefresh();
    }
  }, [countdown]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-background text-foreground">
      <div className="text-center p-8 max-w-md mx-auto">
        {/* Logo do projeto */}
        <div className="mb-8">
          <img 
            src={ASSETS.LOGOS.TRANSPARENT}
            alt="Ephemeral Cards" 
            className="h-40 w-auto mx-auto dark:filter dark:brightness-0 dark:invert"
          />
          {/* Badge Beta igual ao header */}
          <div className="inline-block bg-red-600 text-white text-xs font-bold px-3 py-1 rounded-md uppercase mt-4">
            Beta
          </div>
        </div>

        {/* Card de manutenção */}
        <div className="bg-card text-card-foreground p-8 rounded-lg border shadow-lg">
          <div className="space-y-4">
            <div className="text-6xl mb-4">🔧</div>
            <h1 className="text-3xl font-bold text-primary">Manutenção</h1>
            <p className="text-lg text-muted-foreground">
              {maintenanceMessage}
            </p>
            <p className="text-sm text-muted-foreground">
              {estimatedDuration}
            </p>
            
            {/* Barra de progresso animada */}
            <div className="mt-6">
              <div className="w-full bg-secondary rounded-full h-2 overflow-hidden">
                <div className="h-full bg-primary rounded-full animate-progress"></div>
              </div>
            </div>

            {/* Countdown e botão de refresh */}
            <div className="mt-6 space-y-3">
              <p className="text-sm text-muted-foreground">
                Verificando novamente em: <span className="font-mono font-bold text-primary">{countdown}s</span>
              </p>
              <Button 
                onClick={handleRefresh}
                variant="outline"
                size="sm"
                className="mx-auto"
              >
                <RefreshCw className="h-4 w-4 mr-2" />
                Verificar Agora
              </Button>
            </div>
          </div>
        </div>

        {/* Informações adicionais */}
        <div className="mt-6 text-sm text-muted-foreground">
          <p>Agradecemos a sua paciência 💙</p>
        </div>
      </div>
    </div>
  );
};

export default MaintenancePage;
